module.exports = __webpack_public_path__ + "img/inverterStatus.8f7cf0d7.svg";